"use client";

import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { usePersona } from "@opensea/navigation";
import { isAddressEqual } from "@opensea/utils";
import { useAcceptOffersFlow } from "@opensea/wallet";
import { useTranslations } from "next-intl";
import { useAddress } from "@/hooks/wallet";
import { useAcceptOffersFragment } from "./use-accept-offers.fragment";
import { isItemTradable } from "./validation/tradable";
export const useAcceptOffers = itemKeys => {
  const $ = _c(10);
  const t = useTranslations("useAcceptOffers");
  const items = itemKeys.map(_temp);
  const address = useAddress();
  const {
    persona
  } = usePersona();
  const mode = persona === "advanced" ? "minimized" : "full";
  let t0;
  if ($[0] !== mode) {
    t0 = {
      mode
    };
    $[0] = mode;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const acceptOffersFlow = useAcceptOffersFlow(t0);
  const getDisabledReason = () => {
    if (items.some(item => item?.chain.identifier !== items[0]?.chain.identifier)) {
      return t("errors.differentChains");
    }
    if (items.some(item_0 => isAddressEqual(item_0?.bestOffer?.maker?.address, address))) {
      return t("errors.ownOffer");
    }
    if (items.some(_temp2)) {
      return t("errors.compromisedItem");
    }
    if (items.some(_temp3)) {
      return t("errors.tradingDisabled");
    }
  };
  const disabledReason = getDisabledReason();
  const itemsWithOffers = items.flatMap(_temp4);
  const disabled = Boolean(disabledReason) || itemsWithOffers.length === 0;
  let t1;
  if ($[2] !== acceptOffersFlow || $[3] !== items || $[4] !== itemsWithOffers) {
    t1 = function acceptOffers() {
      if (items.length) {
        acceptOffersFlow(itemsWithOffers.map(_temp5));
      }
    };
    $[2] = acceptOffersFlow;
    $[3] = items;
    $[4] = itemsWithOffers;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const acceptOffers = t1;
  let t2;
  if ($[6] !== acceptOffers || $[7] !== disabled || $[8] !== disabledReason) {
    t2 = {
      disabled,
      disabledReason,
      acceptOffers
    };
    $[6] = acceptOffers;
    $[7] = disabled;
    $[8] = disabledReason;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
function _temp(itemKey) {
  const readItem = readFragment(useAcceptOffersFragment, itemKey);
  return readItem?.tokenId ? {
    ...readItem,
    quantity: itemKey?.quantity,
    orderId: itemKey?.orderId
  } : undefined;
}
function _temp2(item_1) {
  return item_1?.enforcement.isCompromised;
}
function _temp3(item_2) {
  return item_2 && !isItemTradable(item_2);
}
function _temp4(item_3) {
  return item_3?.bestOffer ? [item_3] : [];
}
function _temp5(item_4) {
  return {
    chain: {
      identifier: item_4.chain.identifier
    },
    contractAddress: item_4.contractAddress,
    tokenId: item_4.tokenId,
    quantity: item_4.quantity ?? 1,
    initialPrice: item_4.bestOffer?.pricePerItem.token.unit && item_4.bestOffer.pricePerItem.token.address ? {
      unit: item_4.bestOffer.pricePerItem.token.unit,
      contractAddress: item_4.bestOffer.pricePerItem.token.address
    } : undefined,
    orderId: item_4.orderId
  };
}